import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import CompareCheckbox from './CompareCheckbox';
import { publishVehicleData } from '../../../utilities/vehicleTracking';
import MyCars from './MyCars';

const Footer = ({ shouldShowCompare, isMyCarsSitePropEnabled, link, uuid }) => {
	const labels = useLabels();
	const { windowId, widgetName } = useRequestData();

	return (
		<>
			{shouldShowCompare && <CompareCheckbox uuid={uuid} />}
			{isMyCarsSitePropEnabled && <MyCars uuid={uuid} />}
			<a
				className="more-details-link ml-auto text-link text-link-muted btn-small"
				href={link}
				onClick={() => {
					trackEvent(widgetName, windowId, {
						element: 'View details link',
						result: 'Navigated to VDP'
					});
					publishVehicleData(uuid);
				}}
			>
				{labels.get('MORE_DETAILS')}
				<i className="ddc-icon ddc-icon-arrow1-right pl-3" />
			</a>
		</>
	);
};

Footer.propTypes = {
	shouldShowCompare: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	uuid: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired
};

export default Footer;
